// import { useState } from 'react';
import Heading from '../components/common/Heading';
import LayOut from '../components/common/Layout';
import UnspokenArt from '../components/unspokenArt/UnspokenArt';
// import BuyBookForm from '../components/artBook/BuyBookForm';

export default function Art() {
  // const [showBuyForm, setShowBuyForm] = useState(false);

  return (
    <LayOut layoutStyle="bg-white">
      <div className="pt-16 md:pt-10 lg:pt-14">
        <Heading text="Unspoken Art" customStyle="text-custom-coffee" />
        <div className="mx-auto mt-3 w-10 h-px bg-custom-stone" />

        <section>
          <UnspokenArt />
        </section>
      </div>

      {/* {showBuyForm && <BuyBookForm onClose={() => setShowBuyForm(false)} />} */}
    </LayOut>
  );
}
